<template>
    <div class="layout-box">
        <Header/>
        <div class="main">
            <router-view />
        </div>
        <Footer/>
    </div>
</template>
<script>
import Header from '@/page/supplier/component/header/1.0.1/index.vue'
import Footer from '@/page/distributor/component/basic-layout/1.0.1/component/footer/index.vue'
export default {
    data (){
        return{


        }
    },
    components:{Header,Footer}
}
</script>

<style lang="less" scoped>
.layout-box{
    width: 100%;
    .main{
        min-height: 100vh;
    }

}
</style>
